import { render, staticRenderFns } from "./receiveCoupon.vue?vue&type=template&id=5038b493&scoped=true&"
import script from "./receiveCoupon.vue?vue&type=script&lang=js&"
export * from "./receiveCoupon.vue?vue&type=script&lang=js&"
import style0 from "./receiveCoupon.vue?vue&type=style&index=0&id=5038b493&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5038b493",
  null
  
)

export default component.exports